import React, { FunctionComponent } from 'react'
import { useRouteMatch } from 'react-router-dom'

import { LvDetailDrawer } from '../components/LvDetailDrawer/LvDetailDrawer'
import { PageLayout } from '../components/PageLayout/PageLayout'
import { PostServiceLetterCreateModalButton } from '../components/PostServiceLetterCreateModalButton/PostServiceLetterCreateModalButton'
import { PostServiceSentTable } from '../components/PostServiceSentTable/PostServiceSentTable'
import { postServiceCreatePath } from '../utils/paths'

export const PostServiceSent: FunctionComponent = () => {
  const { path } = useRouteMatch()

  return (
    <>
      <PageLayout
        title="Hromadná pošta"
        isNew
        extra={
          <PostServiceLetterCreateModalButton
            open={path === postServiceCreatePath()}
            buttonText="Vytvořit novou hromadnou poštu"
          />
        }
      >
        <PostServiceSentTable />
      </PageLayout>
      <LvDetailDrawer />
    </>
  )
}

export default PostServiceSent
